import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "@/lib/translations";

const LanguageContext = createContext();
const STORAGE_KEY = "forkfinder_lang";

export function LanguageProvider({ children }) {
  // Default to French (Quebec); persist user's choice in localStorage.
  // Allow ?lang=en|fr query param to override (used for SEO hreflang).
  const [lang, setLang] = useState(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const q = params.get("lang");
      if (q === "en" || q === "fr") {
        try { localStorage.setItem(STORAGE_KEY, q); } catch { /* ignore */ }
        return q;
      }
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === "en" || stored === "fr" ? stored : "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* ignore */ }
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLanguage = () => {
    setLang((prev) => (prev === "en" ? "fr" : "en"));
  };

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
